<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="3" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">基本养老保险</b-th>
          <b-th colspan="3" style="text-align: center">失业保险</b-th>
          <b-th colspan="1" style="text-align: center">工伤保险</b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">基本医疗保险</b-th>
          <b-th colspan="1" style="text-align: center">生育保险</b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">月缴费额</b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(baseFee)="data">
        <div>{{ data.item.baseFee ? Number(data.item.baseFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(pensionFeeDw)="data">
        <div>{{ data.item.pensionFeeDw ? Number(data.item.pensionFeeDw).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(pensionFeeGe)="data">
        <div>{{ data.item.pensionFeeGe ? Number(data.item.pensionFeeGe).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(pensionFee)="data">
        <div>{{ data.item.pensionFee ? Number(data.item.pensionFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(loseFeeDw)="data">
        <div>{{ data.item.loseFeeDw ? Number(data.item.loseFeeDw).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(loseFeeGe)="data">
        <div>{{ data.item.loseFeeGe ? Number(data.item.loseFeeGe).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(loseFee)="data">
        <div>{{ data.item.loseFee ? Number(data.item.loseFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(injuryFee)="data">
        <div>{{ data.item.injuryFee ? Number(data.item.injuryFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(totalFee1)="data">
        <div>{{ data.item.totalFee1 ? Number(data.item.totalFee1).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(medicFeeDw)="data">
        <div>{{ data.item.medicFeeDw ? Number(data.item.medicFeeDw).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(medicFeeGe)="data">
        <div>{{ data.item.medicFeeGe ? Number(data.item.medicFeeGe).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(medicFee)="data">
        <div>{{ data.item.medicFee ? Number(data.item.medicFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(bearFee)="data">
        <div>{{ data.item.bearFee ? Number(data.item.bearFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(totalFee2)="data">
        <div>{{ data.item.totalFee2 ? Number(data.item.totalFee2).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(socialFeeDw)="data">
        <div>{{ data.item.socialFeeDw ? Number(data.item.socialFeeDw).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(socialFeeGe)="data">
        <div>{{ data.item.socialFeeGe ? Number(data.item.socialFeeGe).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(socialFee)="data">
        <div>{{ data.item.socialFee ? Number(data.item.socialFee).toFixed(2) : 0 }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}"></div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(baseFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'baseFee') }}</div>
      </template>
      <template v-slot:foot(pensionFeeDw)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'pensionFeeDw') }}</div>
      </template>
      <template v-slot:foot(pensionFeeGe)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'pensionFeeGe') }}</div>
      </template>
      <template v-slot:foot(pensionFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'pensionFee') }}</div>
      </template>
      <template v-slot:foot(loseFeeDw)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'loseFeeDw') }}</div>
      </template>
      <template v-slot:foot(loseFeeGe)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'loseFeeGe') }}</div>
      </template>
      <template v-slot:foot(loseFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'loseFee') }}</div>
      </template>
      <template v-slot:foot(injuryFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'injuryFee') }}</div>
      </template>
      <template v-slot:foot(totalFee1)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalFee1') }}</div>
      </template>
      <template v-slot:foot(medicFeeDw)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'medicFeeDw') }}</div>
      </template>
      <template v-slot:foot(medicFeeGe)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'medicFeeGe') }}</div>
      </template>
      <template v-slot:foot(medicFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'medicFee') }}</div>
      </template>
      <template v-slot:foot(bearFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'bearFee') }}</div>
      </template>
      <template v-slot:foot(totalFee2)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'totalFee2') }}</div>
      </template>
      <template v-slot:foot(socialFeeDw)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'socialFeeDw') }}</div>
      </template>
      <template v-slot:foot(socialFeeGe)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'socialFeeGe') }}</div>
      </template>
      <template v-slot:foot(socialFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'socialFee') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "HrSalaryCalcSocialDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'employeeName', label: '员工姓名', width: '120px'},
        {key: 'baseFee', label: '月缴费基数', width: '120px'},
        {key: 'pensionFeeDw', label: '单位', width: '120px'},
        {key: 'pensionFeeGe', label: '个人', width: '120px'},
        {key: 'pensionFee', label: '小计', width: '120px'},
        {key: 'loseFeeDw', label: '单位', width: '120px'},
        {key: 'loseFeeGe', label: '个人', width: '120px'},
        {key: 'loseFee', label: '小计', width: '120px'},
        {key: 'injuryFee', label: '单位', width: '120px'},
        {key: 'totalFee1', label: '小计', width: '120px'},
        {key: 'medicFeeDw', label: '单位', width: '120px'},
        {key: 'medicFeeGe', label: '个人', width: '120px'},
        {key: 'medicFee', label: '小计', width: '120px'},
        {key: 'bearFee', label: '单位', width: '120px'},
        {key: 'totalFee2', label: '小计', width: '120px'},
        {key: 'socialFeeDw', label: '单位', width: '120px'},
        {key: 'socialFeeGe', label: '个人', width: '120px'},
        {key: 'socialFee', label: '合计', width: '120px'},


      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
    let adjustType = this.$route.query.adjustType
    if (adjustType === '2') {
      this.fields.splice(4, 1)
    } else if(adjustType === '1') {
      this.fields.splice(5, 1)
    }
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total
      }, new Decimal(0)).toFixed(2, Decimal.ROUND_HALF_UP);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
